import React, {useEffect, useState} from 'react';
// import {Col, Row} from "react-bootstrap";
import '../../Styles/Taetigkeitsbericht/taetigkeiten.css';
import {getToken} from "../../Utils/Common";
import AppWebReportStundenImageSliderComponent from "./AppWebReportStundenImageSliderComponent";
import AppWebReportImagePreview from "./AppWebReportImagePreview";
function AppWebReportStundenTaetigkeiten(props) {

    const [taetigkeitenData, setTaetigkeitenData] = useState(props.taetigkeitenData);
    const [taetigkeitenImages, setTaetigkeitenImages] = useState([]);
    const [updatedImages, setUpdatedImages] = useState([]);
    const [updatedIndex, setUpdatedIndex] = useState(-1);
    const [previewImage, setPreviewImage] = useState('');
    const [previewShown, setPreviewShown] = useState(false);

    useEffect(() => {
        setTaetigkeitenData(props.taetigkeitenData);
    }, [props.originState, props.taetigkeitenData]);

    async function getCDNImages() {

        let theCDNImages = [];

        if (props.taetigkeitenData !== undefined) {

            await Promise.all(props.taetigkeitenData?.map(async (item) => {
                let retrievedImagesInner = [];
                await Promise.all(item.pictures.map(async (itemInner) => {
                    const response = await fetch(
                        process.env.REACT_APP_BACKEND_API_URI + "mobileappwebreport/getpresignedurl",
                        {
                            method: 'POST',
                            headers: {
                                'Content-type': 'application/json',
                            },
                            body: JSON.stringify({"token": getToken(), "data": {"object_path": itemInner.url}}),
                        })
                    const data = await response.json();
                    retrievedImagesInner.push(data);
                }));
                return retrievedImagesInner;
            })).then((values) => {
                for (const innerARR of values) {
                    let x = innerARR.map((item) => {
                        return item.url;
                    });
                    theCDNImages.push(x)
                }
            });
        }
        return theCDNImages

    }

    useEffect(async () => {
        let retrievedImages = await getCDNImages()
        setTaetigkeitenImages(retrievedImages);
    }, [props.originState, props.stundenReportData]);

    useEffect(() => {

        if (updatedIndex !== -1) {

            let updatedStundenReportData = props.stundenReportData;
            let updatedTaetigkeitenData = {}

            if (props.type === "Stunden-Anmeldung") {
                updatedTaetigkeitenData = updatedStundenReportData.taetigkeiten_angemeldet;
            }

            let updatedTaetigkeitenPictures = updatedTaetigkeitenData[updatedIndex]?.pictures;

            let updatedTaetigkeitenPicturesData = [];

            updatedTaetigkeitenPictures.forEach((item) => {
                let found = false;
                updatedImages.forEach((image) => {
                    if (item.url === image) {
                        found = true;
                    }
                });
                if (found) {
                    updatedTaetigkeitenPicturesData.push(item);
                }
            });

            updatedTaetigkeitenData[updatedIndex].pictures = updatedTaetigkeitenPicturesData;

            if (updatedTaetigkeitenPicturesData.length === 0) {
                updatedTaetigkeitenData.splice(updatedIndex, 1);
            }

            updatedStundenReportData.taetigkeiten = updatedTaetigkeitenData;

            props.setStundenReportData(updatedStundenReportData);

        }

    }, [updatedImages, updatedIndex]);


    function handleTaetigkeitenChange(id, value) {

        props.setIsChange(false)
        props.taetigkeitenData.map((item) => {

            if ((item.id) === id) {
                item.description = value;
            }

        })

    }

    function getTaetigkeitenIndividual(item, index) {

        return (
            <div
                style={{
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'flex-start',
                    justifyContent: 'space-between',
                    height: '50vh',
                    width: '100%',
                    // backgroundColor:'green'
                }}
            >
                {taetigkeitenImages[index]?.length ? (
                    <AppWebReportStundenImageSliderComponent
                        type={'taetigkeiten'}
                        setIsChange={props.setIsChange}
                        isOrigin={!props.originState}
                        images={taetigkeitenImages[index]}
                        setImages={setTaetigkeitenImages}
                        taetigkeitenImages={taetigkeitenImages}
                        width={'40%'}
                        height={'50vh'}
                        setUpdatedImages={setUpdatedImages}
                        setUpdatedIndex={setUpdatedIndex}
                        setPreviewImage={setPreviewImage}
                        setPreviewShown={setPreviewShown}
                    />
                ) : null}
                {taetigkeitenImages[index]?.length !== 0 && (
                    <textarea
                        className="handwai-dark handwai-text-label-normal add-bottom-21-padding"
                        style={{ height: '100%', width:'68%' }}
                        disabled={props.originState}
                        rows={7}
                        key={item.description}
                        defaultValue={item.description}
                        onChange={(event) => handleTaetigkeitenChange(item.id, event.target.value)}
                    />
                )}
                {previewShown && (
                    <AppWebReportImagePreview
                        previewImage={previewImage}
                        previewShown={previewShown}
                        setPreviewShown={setPreviewShown}
                    />
                )}
            </div>
        );
    }

    function getTaetigkeiten(taetigkeitenData) {
        return taetigkeitenData?.map((item, index) => getTaetigkeitenIndividual(item, index))
    }

    return (
        <>
            <div>{getTaetigkeiten(taetigkeitenData)}</div>
            {/*<div className="tatigkeiten-div-scroll">{getTaetigkeiten(taetigkeitenData)}</div>*/}

        </>
    );

}

export default AppWebReportStundenTaetigkeiten;
